import axios from 'axios';
import type { GetSimpleListingsByIdsDTO } from '@/app-package';

const getSimpleTeamListings = async (teamId: string) => {
  const {
    data: { listings },
  } = await axios.get<GetSimpleListingsByIdsDTO>(
    `/listing/team_listings/${teamId}`,
  );

  return listings;
};
export default getSimpleTeamListings;
